import { Box, Button, Card, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { apiUrl, httpClient } from '../../utils/httpUtils';
import { Graphic } from './Graphic';

const SeeReportButton = ({ data }) => {
  const translate = useTranslate();
  return (
    <Button
      component={RouterLink}
      to="/reports-teams"
      state={{ ...data }}
      variant="outlined"
      sx={{ padding: '8px 20px' }}
    >
      {translate('resources.dashboard.list.card_graphic.btn')}
    </Button>
  );
};

export const GraphicCard = () => {
  const translate = useTranslate();
  const [data, setData] = useState([]);
  const notify = useNotify();

  const fetchData = async () => {
    try {
      const res = await httpClient(apiUrl + '/metrics/summary');
      if (res.status && res.status === 200) {
        const resp = res.json;
        const metrics = resp.metrics || [];
        const target_notes = resp.target_notes || 0;
        const target_subscribers = resp.target_subscribers || 0;
        const target_visits = resp.target_visits || 0;

        const now = new Date();
        const currentMonth = now.getUTCMonth() + 1;
        const currentYear = now.getUTCFullYear();
        const daysInMonth = new Date(currentYear, currentMonth, 0).getUTCDate();

        const processedData = {};

        metrics.forEach(item => {
          const date = new Date(item.view_date);
          const day = date.getUTCDate();

          const total_notes =
            target_notes === 0 ? 0 : (item.total_notes * 100) / target_notes;
          const total_subscribers =
            target_subscribers === 0
              ? 0
              : (item.total_subscribers * 100) / target_subscribers;
          const total_visits =
            target_visits === 0 ? 0 : (item.total_visits * 100) / target_visits;

          processedData[day] = {
            date: `${day < 10 ? `0${day}` : `${day}`}/${currentMonth}`,
            total_notes: Number(total_notes) || 0,
            total_subscribers: Number(total_subscribers) || 0,
            total_visits: Number(total_visits) || 0,
          };
        });
        const completeData = Array.from({ length: daysInMonth }, (_, index) => {
          const day = index + 1;
          return (
            processedData[day] || {
              date: `${day < 10 ? `0${day}` : `${day}`}/${currentMonth}`,
              total_notes: null,
              total_subscribers: null,
              total_visits: null,
            }
          );
        });
        setData(completeData);
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
      notify(translate('errors.default'), { type: 'error' });
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        color: '#000',
        padding: '24px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          height: 'fit-content',
          marginBottom: '26px',
        }}
      >
        <Typography fontSize={26} fontWeight="600">
          {translate('resources.dashboard.list.card_graphic.title')}
        </Typography>
        <SeeReportButton data={data} />
      </Box>
      <Box
        flexDirection={{ xs: 'column', md: 'row' }}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '48px',
        }}
      >
        <Graphic data={data} />
        {/* <Box
          margin={{ xs: '0 auto', md: '0' }}
          sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
        >
          {data.length > 0 &&
            Object.keys(data[0])
              .slice(1)
              .map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    minWidth: '200px',
                    height: '100%',
                    maxHeight: '72px',
                    gap: '12px',
                    padding: '24px',
                    border: '1px solid' + customPalette.greyStoke,
                    borderRadius: '10px',
                  }}
                >
                  <Typography
                    fontSize={16}
                    fontWeight="600"
                    sx={{ textTransform: 'capitalize' }}
                  >
                    {translate(
                      'resources.dashboard.list.card_graphic.fields.' +
                        item.split('_')[1]
                    )}
                  </Typography>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    {data[0][item] === 0 ? (
                      <TrendingFlat sx={{ color: customPalette.greyDark }} />
                    ) : data[0][item] < 1.5 ? (
                      <TrendingDown sx={{ color: customPalette.negative }} />
                    ) : (
                      <TrendingUp sx={{ color: customPalette.positive }} />
                    )}
                    <Typography
                      fontSize={18}
                      fontWeight="600"
                      color={
                        data[0][item] === 0
                          ? customPalette.greyDark
                          : data[0][item] < 1.5
                            ? customPalette.negative
                            : customPalette.positive
                      }
                    >
                      {typeof data[0][item] === 'number' &&
                      data[0][item] % 1 !== 0
                        ? data[0][item].toFixed(2)
                        : data[0][item]}
                      %
                    </Typography>
                  </Box>
                </Box>
              ))}
        </Box> */}
      </Box>
    </Card>
  );
};
